import { Box, Typography, Card, CardContent, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PrimaryButtom from "../../../components/buttons/PrimaryButton";

import { MODULES } from "../../../config/modules.config";
import { getServiceTabs } from "./constant";
import { useAuth } from "../../../contexts/AuthContext";

const tealPrimary = "#1DA7A7";
const tealAccent = "#00BFA5";

const Decoration = styled(Box)(({ position, size, color }) => ({
  position: "absolute",
  borderRadius: "50%",
  opacity: 0.08,
  pointerEvents: "none",
  width: size,
  height: size,
  background: color,
  ...position,
}));

const Services = () => {
  const navigate = useNavigate();

  const { effectiveRoles, hasAccess } = useAuth();

  const visibleModules = MODULES.filter((module) => {
    if (!module.role) return true;

    const hasModuleRole = hasAccess(module.role);
    const hasAccessContentRole = effectiveRoles.some(
      (role) => module.accessContent?.[role],
    );

    return hasModuleRole || hasAccessContentRole;
  });

  const serviceTab = getServiceTabs(visibleModules, effectiveRoles, hasAccess);

  const handleNavigate = (route) => {
    navigate(route);
  };

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          textAlign: "left",
          fontWeight: 600,
          p: 1,
          pl: 4,
          borderRadius: 2,
          color: "#FFFFFF",
          background: {
            xs: "linear-gradient(45deg, #1DA7A7 50%, #FFFFFF 50%)",
            md: "linear-gradient(45deg, #1DA7A7 30%, #FFFFFF 30%)",
          },
          borderBottom: "1px solid #1DA7A7",
          borderBottomRightRadius: 0,
          lineHeight: "1.8",
        }}
      >
        Tools
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
          },
          gap: 4,
          mt: 6,
        }}
      >
        {serviceTab.map((item) => (
          <Card
            key={item.id}
            sx={{
              position: "relative",
              overflow: "hidden",
              border: "1px solid #E5F2F0",
              borderRadius: 3,
              p: 2,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              transition: "0.3s",
              borderTop: `4px solid ${tealPrimary}`,
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
              },
            }}
          >
            <Decoration
              position={{ bottom: "-50px", right: "-50px" }}
              size="200px"
              color={tealPrimary}
            />

            <Decoration
              position={{ top: "-40px", left: "-40px" }}
              size="150px"
              color={tealAccent}
            />

            <CardContent sx={{ textAlign: "left" }}>
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: item.bgColor,
                  color: "#fff",
                  fontSize: 32,
                  mb: 2,
                }}
              >
                {item.icon}
              </Box>

              <Typography
                variant="h6"
                fontWeight={600}
                gutterBottom
                sx={{ color: "#222" }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 2, minHeight: 50 }}
              >
                {item.description}
              </Typography>

              <PrimaryButtom
                text={item.buttonText}
                onClick={() => handleNavigate(item.route)}
                endIcon={<KeyboardArrowRightIcon />}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default Services;
